// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"799":"57d9ab57","889":"e1ea31c9"}[chunkId] + ".css";
};